import * as _ from 'lodash';
import { ColumnHandler } from '../types';
import { parseJson, parseDatetime, parseString } from '../converters';
import { EmailColumnType } from '../../monday-api/api';

export type EmailColumnValue = {
  text: string | null;
  label: string | null;
  email: string | null;
  changed_at: string | null;
};

const handler: ColumnHandler<EmailColumnType, EmailColumnValue> = {
  type: 'email',

  default_value_field: 'text',

  supported_rules: [
    {
      operator: 'any_of',
      compare_value_ids: ['empty_string', 'text'],
    },
    {
      operator: 'not_any_of',
      compare_value_ids: ['empty_string', 'text'],
    },
    {
      operator: 'is_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'is_not_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'contains_text',
      compare_value_ids: ['text'],
    },
    {
      operator: 'not_contains_text',
      compare_value_ids: ['text'],
    },
  ],

  convertValueFromMondayToEngine: (columnValue) => {
    const text = parseString(columnValue.text);
    const value = parseJson(columnValue.value);
    const label = parseString(_.get(value, 'text'));
    const email = parseString(_.get(value, 'email'));
    const changedAt = parseDatetime(_.get(value, 'changed_at'));

    return {
      text,
      label,
      email,
      changed_at: changedAt,
    };
  },

  convertValueFromEngineToUpdateValue: (engineValue) => {
    return engineValue.email;
  },

  getFormulaValue: (engineValue) => (engineValue.email === null ? '' : engineValue.email),
};

export default handler;
